import { render, staticRenderFns } from "./PersonaProgramaSubPage.vue?vue&type=template&id=0ccca54f"
import script from "./PersonaProgramaSubPage.js?vue&type=script&lang=js&external"
export * from "./PersonaProgramaSubPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports